import { useSelector } from "react-redux";
import translations from "../languages";

export const useTranslate = () => {
  const { language } = useSelector((state) => state.language);

  const translate = (key) => {
    if (translations[language.value] && translations[language.value][key]) {
      return translations[language.value][key];
    }
    return key;
  };

  return translate;
};
